import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import { getGoodFgKickedToSpot } from "../utils/context-utils";
import FootballState from "../state/football-state";

export default class FieldGoalGood extends Fragment {
    constructor() {
        super();
        this.code = "G";
    }

    summarize(summaryContext, stringifier, play) {
        const fieldLength = summaryContext.gameConfig.general.fieldLength;
        const kickedTo = summaryContext.homeTeamHasPossession ? fieldLength : 0;
        return new FragmentSummary(
            ` for ${stringifier.gain(
                summaryContext,
                summaryContext.fieldPosition,
                getGoodFgKickedToSpot(summaryContext, kickedTo),
                false
            )}${play.historyContains(FootballState.PatTry) ? "" : " was good"}`
        );
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
